import { useCallback, useEffect, useRef, useState } from 'react'
import { checkFloatValid } from '../globals/numbers'

export interface MyDebounceProps {
    value: string
    onChange: (value: string) => void
    onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
    timeDebounce?: number
    readOnly?: boolean
    isNumber?: boolean
}

const useMyDebounce = ({ value, onChange, onBlur, readOnly, isNumber, timeDebounce =1000 }: MyDebounceProps) => {
    const [myValue, setMyValue] = useState(value)
    const [haveToTrigger, setHaveToTrigger] = useState<boolean>(false)
    const ref = useRef<any>(null)

    const changeMyValue = useCallback((changedValue: string) => {
        setHaveToTrigger(true)
        setMyValue(changedValue)
    }, [setMyValue, setHaveToTrigger])

    const myOnBlur: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> = useCallback((e) => {
        if (!readOnly) {
            if (onBlur) {
                onBlur(e)
                setHaveToTrigger(false)
            } else if (haveToTrigger) {
                let val = e.currentTarget.value
                if(isNumber && val !== ''){
                    const valid = checkFloatValid(val)
                    val = valid || ''
                }
                onChange(val)
                setHaveToTrigger(false)
            }
        }
    }, [onBlur, onChange, readOnly, haveToTrigger, isNumber])

    useEffect(() => {
        if (haveToTrigger !== false) {
            let id = setInterval(() => {
                if (ref.current) {
                    const myDebounceValue = ref.current.getAttribute('debouncevalue') || ref.current.value
                    if (myDebounceValue === myValue) {
                        onChange(myDebounceValue);
                        setHaveToTrigger(false)
                    }
                } else {
                    const myDebounceValue = ref?.current?.getAttribute('debouncevalue') || ref?.current?.value
                    onChange(myDebounceValue);
                    setHaveToTrigger(false)
                }
            }, timeDebounce)
            return () => clearInterval(id)
        }
    }, [haveToTrigger, onChange, myValue, timeDebounce])

    useEffect(() => {
        setMyValue(value)
    }, [value])

    return { myValue, changeMyValue, ref, myOnBlur }
}

export default useMyDebounce